export default "/images/plus.svg?1a7aad070e64d60e1cdd08ecd9c39731";